import { ComponentNameEnum, BaseStepperPxPercentSliderFieldConfig } from '@/types';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';

export const getTeaserMaxWidth = (): number => {
  const template = getTemplateIframeDocument();
  if (!template) return 250;

  const spmBody = template.querySelector('#spm_body.spm_teaser') as HTMLElement;
  if (spmBody && spmBody.classList.contains('spm_shape_circle')) {
    return 120;
  }
  return 250;
};

const getTeaserWidthFieldConfig = (defaultValue = 250): BaseStepperPxPercentSliderFieldConfig => ({
  componentName: ComponentNameEnum.STEPPER_PX_PERCENT_SLIDER,
  options: {
    px: {
      min: 50,
      max: getTeaserMaxWidth(),
      step: 1,
      defaultValue,
      isDefaultUnitSelected: true,
    },
  },
});

export default getTeaserWidthFieldConfig;
